export class UserLoginRequest {
    public userName: string;
    public password: string;
    type?: string;

    constructor(userName: string, password: string, type = 'EMAIL'){
        this.userName = userName;
        this.password = password;
        this.type = type;
    }
}